import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { computed } from 'vue'
import Card from '@/views/dashboard/_components/card/card.vue'
import TerminalDistributionChart from '@/views/dashboard/overview/_components/asset-status-zone/_components/terminal-distribution-chart.vue'
import TimeRangeSelect from '@/views/dashboard/_components/time-range-select/time-range-select.vue'
import { TimeRange } from '@/views/dashboard/_components/time-range-select/time-range.enum'

interface TypeItem {
  name: string
  value: number
}


export default /*#__PURE__*/_defineComponent({
  __name: 'outbound-type-chart',
  props: {
    data: { default: () => [
    { name: '财务报表', value: 10 },
    { name: '身份信息', value: 15 },
    { name: '工资奖金', value: 20 },
    { name: '技术方案', value: 25 },
    { name: '其他', value: 17 }
  ] },
    timeRange: { default: TimeRange.DAYS_30 }
  },
  emits: ["update:timeRange"],
  setup(__props: any, { emit: __emit }) {

const props = __props

const emit = __emit

const timeRange = computed({
  get: () => props.timeRange,
  set: (val) => emit('update:timeRange', val)
})

const chartData = computed(() => props.data)

return (_ctx: any,_cache: any) => {
  const _component_el_tag = _resolveComponent("el-tag")!

  return (_openBlock(), _createBlock(Card, {
    size: "second",
    title: _ctx.$t('sensitiveFileScanning.outboundTypeTitle'),
    class: "type-chart-card"
  }, {
    titleAfter: _withCtx(() => [
      _createVNode(_component_el_tag, {
        size: "small",
        type: "primary"
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('common.rankTagTops')), 1)
        ]),
        _: 1
      })
    ]),
    headerRight: _withCtx(() => [
      _createVNode(TimeRangeSelect, {
        modelValue: timeRange.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((timeRange).value = $event)),
        showAll: false
      }, null, 8, ["modelValue"])
    ]),
    default: _withCtx(() => [
      _createVNode(TerminalDistributionChart, {
        data: chartData.value,
        "center-title": _ctx.$t('sensitiveFileScanning.outboundTypeCenterTitle'),
        unit: "个"
      }, null, 8, ["data", "center-title"])
    ]),
    _: 1
  }, 8, ["title"]))
}
}

})